// @ts-nocheck
import Messenger from "../common/Messenger"

const AdminMessenger = (props) => {
    return (
        <Messenger {...props} />
    )
}

export default AdminMessenger